import axios from "axios";

export interface Module {
  id: string;
  name: string;
  description: string;
}

export function getAllModules() {
  return axios
    .get<{ data: Module[]; success: boolean }>("/Modules/getallmodules")
    .then((res) => res.data.data);
}
